<template>
    <h2>Provider Cost Comparison</h2>

    <p class="mx-auto col-md-9 mb-4 lead">
        As you built a plan we can estimate the cost of any provider charges in £ terms over the course of your 
        whole retirement below and compare a current provider to any other.
    </p>

    <provider-cost-estimator
        :industryAverageCharge="industryAverageCharge"
        upperText="Current Provider annual charges"
        @charge-rate-changed="currentProviderChargeRateChanged">
    </provider-cost-estimator>

    <provider-cost-estimator
        :industryAverageCharge="industryAverageCharge"
        upperText="Other Provider annual charges"
        @charge-rate-changed="otherProviderChargeRateChanged">
    </provider-cost-estimator>

    <p class="my-4">
        The other Provider annual charges are <span v-if="displayChargeDifference">{{ chargeDifferenceText }}</span> {{ moreOrLessText }} over 
        your retirement period alone.
    </p>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import ProviderCostEstimator from "@/guiide/components/guiideplus/providers/ProviderCostEstimator.vue";
import { app } from "@/guiide/ts/app";
import { formatter } from "@/shared/ts/formatter";

onMounted(async () => {
    const providerCharges = await app.getProviderCharges();
    industryAverageCharge.value = providerCharges.industryAverage;
});

const industryAverageCharge = ref(0);
const currentProviderCharge = ref(0);
const otherProviderCharge = ref(0);

function currentProviderChargeRateChanged(chargeRate: number, cost: number) {
    currentProviderCharge.value = cost;
}

function otherProviderChargeRateChanged(chargeRate: number, cost: number) {
    otherProviderCharge.value = cost;
}

const chargeDifference = computed(() => otherProviderCharge.value - currentProviderCharge.value);
const chargeDifferenceText = computed(() => formatter.formatCurrency(Math.abs(chargeDifference.value)));
const displayChargeDifference = computed(() => chargeDifference.value != 0);
const moreOrLessText = computed(() => {
    if (chargeDifference.value == 0) {
        return "the same";
    } else if (chargeDifference.value < 0) {
        return "less";
    } else {
        return "more";
    }
})
</script>
